import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { COLORS } from '../../constants';
/**
 * Alert Component
 *
 * This component serves as a customizable alert box with an icon and text. It is designed to display
 * warnings or important information within the application. The alert's appearance is customizable,
 * including colors, icon, and text, with responsive adjustments for web.
 *
 * Props:
 * - FontAwesomeIcon (component): Icon component used within the alert.
 * - iconProps (object): Properties to configure the icon component such as icon type, color, and size.
 * - backgroundColor (string): Background color of the alert box.
 * - title (string): Title text of the alert.
 * - description (string): Description text of the alert.
 * - titleColor (string): Color of the title text.
 * - descriptionColor (string): Color of the description text.
 *
 **/
const Alert = ({
    FontAwesomeIcon,
    iconProps,
    backgroundColor,
    title,
    description,
    titleColor,
    descriptionColor
}) => {
    const webStyle = Platform.OS === 'web' ? {
        maxWidth: 600,
    } : {};

    return (
        <View style={[styles.container, { backgroundColor }, webStyle]}>
            <FontAwesomeIcon {...iconProps} style={styles.icon} />
            <View style={styles.textContainer}>
                <Text style={[styles.title, { color: titleColor }]}>{title}</Text>
                <Text style={[styles.description, { color: descriptionColor }]}>{description}</Text>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        borderRadius: 5,
        marginBottom: 10,
        borderColor: COLORS.warning,
        borderWidth: 1,
        shadowColor: COLORS.textDark,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    icon: {
        marginRight: 16
    },
    textContainer: {
        flex: 1
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 4
    },
    description: {
        fontSize: 14,
        lineHeight: 24
    }
});

export default Alert;
